module.exports = __webpack_public_path__ + "static/media/BlurbBottom.3d5a65fb.png";